// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__UtF2s","label":"SetPasswdForm_label__12Zrd"};